/*    
<summary>
  This functional component "ClientFilterForm" provides form to get data based on filter
  Developer:Aashish Singh, Created Date:20-March-2024
</summary>
<returns>Returns JSX</returns>
*/
import { Field, Form, Formik, useFormikContext } from "formik";
import React from "react";
import { Button, Modal, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import FormLoader from "../../../shared-components/FormLoader/FormLoader";
import FormikFormTimePicker from "../../../shared-components/FormikFormHandlers/FormikFormTimePicker";
import {
  ChangeShiftValidationSchema,
  FreeShiftValidationSchema,
  PublishScheduleValidationSchema,
} from "../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import LoaderButton from "../../../shared-components/button/loader-button";
import Label from "../../../shared-components/label/label";
import moment from "moment";
import FormikFormSelectField from "../../../shared-components/FormikFormHandlers/FormikFormSelectField";
import { IOption, IOptionShiftSchedule } from "../../../models/ICommon";
import FormikFormSelect from "../../../shared-components/FormikFormHandlers/FormikFormSelect";

interface IProps {
  submitHandler: (values: any) => void;
  onModalClosed: () => void;
  actionInProgress: boolean;
  initialValues: any;
  storeId: number;
  shiftOptions: IOptionShiftSchedule[];
}

const ChangeShiftForm = (props: IProps) => {
  const { submitHandler, onModalClosed, initialValues, actionInProgress } =
    props;

  const FormObserver: React.FC = () => {
    const { values } = useFormikContext<any>();
    return null;
  };

  return (
    <>
      <Modal className="add-user-modal filter-from " show={true} centered>
        <Modal.Header>
          <Modal.Title>
            <FormattedMessage id={`change_shift`} />
          </Modal.Title>
          <div onClick={onModalClosed} className="Crossicons">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="23"
              fill="currentColor"
              className="bi bi-x"
              viewBox="0 0 16 16"
            >
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </div>
        </Modal.Header>
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validateOnBlur={true}
          validateOnChange={true}
          validationSchema={ChangeShiftValidationSchema}
          onSubmit={async (values: any) => {
            submitHandler({
              Shift: props.shiftOptions.find(
                (x) => x.id === Number(values.Shift)
              )?.data,
            });
          }}
        >
          {({ values }) => (
            <Form className="user-form" noValidate>
              {actionInProgress && <FormLoader loading={actionInProgress} />}
              <FormObserver />
              <Modal.Body>
                <Row className="date-range">
                  <div className="form-group mb-3">
                      <Label
                        className="label-style"
                        required={true}
                        label="select_shift"
                      />
                      <Field
                        className="form-control"
                        name="Shift"
                        //   type="text"
                        //   placeholder="enter_store_name"
                        options={props.shiftOptions}
                        as={FormikFormSelect}
                      />
                  </div>
                </Row>

                {/* {
                  err &&
                  <div className="error-text text-center w-100">
                  <span data-testid="testError" className="text-danger errorMessage ">
                    <FormattedMessage id="please_select_at_least_1_field" />
                  </span>
                  </div>
                } */}
              </Modal.Body>
              <div className="modal-footer border-0">
                <div className="m-auto">
                  <LoaderButton
                    type="submit"
                    isLoading={actionInProgress}
                    disabled={actionInProgress}
                    text={`apply`}
                    iconName="bi-check-lg"
                    className="me-2"
                  />
                  <Button
                    variant="outline-danger"
                    onClick={onModalClosed}
                  >
                    <i className="bi bi-x-lg me-1"></i>
                    <FormattedMessage id="button_cancel" />
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default ChangeShiftForm;
